"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Composer = _interopRequireDefault(require("./Composer"));

var _SayPrimitive = _interopRequireDefault(require("./SayPrimitive"));

var Say = function Say(props) {
  return _react["default"].createElement(_Composer["default"], {
    speechSynthesis: props.speechSynthesis,
    speechSynthesisUtterance: props.speechSynthesisUtterance
  }, _react["default"].createElement(_SayPrimitive["default"], {
    lang: props.lang,
    onBoundary: props.onBoundary,
    onEnd: props.onEnd,
    onError: props.onError,
    onStart: props.onStart,
    pitch: props.pitch,
    rate: props.rate,
    speak: props.speak,
    voice: props.voice,
    volume: props.volume
  }, props.children));
};

Say.defaultProps = {
  speechSynthesis: window.speechSynthesis || window.webkitSpeechSynthesis,
  speechSynthesisUtterance: window.SpeechSynthesisUtterance || window.webkitSpeechSynthesisUtterance
};
Say.propTypes = {
  lang: _propTypes["default"].string,
  onBoundary: _propTypes["default"].func,
  onEnd: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onStart: _propTypes["default"].func,
  pitch: _propTypes["default"].number,
  rate: _propTypes["default"].number,
  speechSynthesis: _propTypes["default"].any,
  speechSynthesisUtterance: _propTypes["default"].any,
  speak: _propTypes["default"].string,
  voice: _propTypes["default"].oneOfType([_propTypes["default"].any, _propTypes["default"].func]),
  volume: _propTypes["default"].number
};
var _default = Say;
exports["default"] = _default;